<app-main-dialog (dismiss)="dismiss()">
  <div desktopTitle>
    {{ siteS().name }}
  </div>
  <app-segment-list [segmentValue]="segmentValue()"
    [segmentButtons]="segmentButtons"
    (segmentChanged)="segmentChanged($event)"></app-segment-list>
  @if (segmentValue() === 'list') {
    <app-list-rooms [site]="siteS()"
      [preSelected]="preSelected$ | async"
      (selected)="onSelect($event)"></app-list-rooms>
  } @else if (segmentValue() === 'map') {
    <ion-item lines="none"
      class="full-width">
      <ion-select interface="popover"
        label-placement="stacked"
        [value]="selectedBlueprint()"
        (ionChange)="onBlueprint($event)">
        @for (print of blueprints; track $index) {
          <ion-select-option [value]="print">
            {{ print.name }}
          </ion-select-option>
        } @empty {
          <app-no-results></app-no-results>
        }
      </ion-select>
    </ion-item>
    @if (imageElement()) {
      <app-area-map [imgElement]="imageElement()"
        [floor]="selectedBlueprint().name"
        [site]="siteS()"
        [selectArea]="true"
        (selectedArea)="onArea($event)"></app-area-map>
    } @else if (selectedBlueprint()) {
      <img id="blueprint"
        [src]="selectedBlueprint().url"
        (load)="setBlueprintImage($event)" />
    }
  }
  @if (clearButtonS()) {
    <ion-button color="light"
      shape="round"
      (click)="clear()">
      <ion-icon slot="start"
        name="close-outline"></ion-icon>
      {{ 'general.clear' | translate }}
    </ion-button>
  }
</app-main-dialog>
@if (isMultiple() || isMultipleRooms()) {
  <ion-fab slot="fixed"
    horizontal="end"
    vertical="bottom">
    <div class="card">
      {{ 'tickets.selecting' | translate: { num: selected().length } }}
      <ion-button [disabled]="selected().length === 0"
        shape="round"
        (click)="onSelectMultiple()">
        {{ 'general.accept' | translate }}
      </ion-button>
      @if (selected().length > 0) {
        <div class="flex-center">
          <span class="link"
            (click)="selectNone()">{{ 'item.removeSelected' | translate }}</span>
        </div>
      }
    </div>
  </ion-fab>
}